module.exports = __webpack_public_path__ + "img/3.4023a238.png";